import { render, staticRenderFns } from "./PinCommentModal.vue?vue&type=template&id=4dcd7260&"
import script from "./PinCommentModal.vue?vue&type=script&lang=js&"
export * from "./PinCommentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports